module.exports = __webpack_public_path__ + "static/img/5 2017年10月.67f8517d.jpg";